import Answers from '@ui/components/Voting/components/Answers/Answers';
import Result from '@ui/components/Voting/components/Result/Result';
import React, { useEffect, useState } from 'react';
import { useRadioStore } from '@ariakit/react';
import PropTypes from 'prop-types';

const VotingList = ({
  answers,
  id,
  onSubmitValue,
  question,
  results = null,
}) => {
  const [value, setValue] = useState();
  const radio = useRadioStore({ value, setValue });

  useEffect(() => {
    if (value) {
      onSubmitValue('list', value);
    }
  }, [value]);

  const selectedIndex = answers?.findIndex(answer => answer === value);

  return !results ? (
    <Answers answers={answers} id={id} question={question} store={radio} />
  ) : (
    <Result
      question={question}
      results={results}
      selectedIndex={selectedIndex}
    />
  );
};

VotingList.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.string.isRequired,
  onSubmitValue: PropTypes.func.isRequired,
  question: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      percentage: PropTypes.number,
    }),
  ),
};

export default VotingList;
